import React, { useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as yup from "yup";
import { Grid } from "@mui/material";
import { Form } from "react-final-form";
import Stack from "@mui/material/Stack";
import UiInput from "../../../_uiComponents/UiInput";
import { UiButton } from "../../../_uiComponents/common/form/UiButton";
import Validator from "../../../../_helpers/validate.schema";
import { FORM_TYPE_EDIT, FORM_TYPE_ADD } from "../../../../_helpers/constants";
import {
     lookupTableValueAddRequest,
     lookupTableValueUpdateRequest,
} from "../../../../_redux/_actions";
import { Context } from "../../../../_context/Store";
import { contextApiActions } from "../../../../_redux/_constants";
import UiDatePicker from "../../../_uiComponents/common/form/UiDatePicker";
import { datePickerToGmtFormat } from "../../../../_helpers/support.services";

const validateSchema = () =>
     yup.object().shape({
          name: yup.string().required("Name is required."),
     });

const onValidate = async (values) => {
     return await Validator(values, validateSchema);
};

export default function LookupTableAddRowForm(props) {
     const actionDispatch = useDispatch();

     const [state, dispatch] = useContext(Context);

     const closeFormModal = () => {
          dispatch({
               type: contextApiActions.UI_MODAL_TOGGEL,
               payload: {
                    show: false,
               },
          });
     };

     const { tableValueDetails } = useSelector((state) => {
          return {
               tableValueDetails: state.lookupTable.tableValueDetails,
          };
     });

     const submit = async (values) => {
          if (props.type === FORM_TYPE_EDIT) {
               actionDispatch(
                    lookupTableValueUpdateRequest({
                         id: tableValueDetails.id,
                         value: values.name,
                         lookupTableId: props.tableId,
                         page:props?.page,
                         rowsPerPage: props?.rowsPerPage,
                         closeFormModal,
                    }),
               );
          } else {
               actionDispatch(
                    lookupTableValueAddRequest({
                         value: values.name,
                         lookupTableId: props.tableId,
                         page:props?.page,
                         rowsPerPage: props?.rowsPerPage,
                         closeFormModal,
                    }),
               );
          }
     };

     return (
          <Form
               onSubmit={submit}
               validate={onValidate}
               initialValues={
                    props.type === FORM_TYPE_EDIT && {
                         name: tableValueDetails.value,
                    }
               }
               render={({ handleSubmit }) => (
                    <form onSubmit={validateSchema}>
                         <>
                              <Grid
                                   container
                                   spacing={2}
                                   sx={{
                                        mt: 1,
                                   }}
                              >
                                   <Grid item xs={12} lg={12}>
                                        {props.tableType == "Date" ? (
                                             <UiDatePicker
                                                  name="name"
                                                  range={false}
                                                  label="Date"
                                                  value={
                                                       props.type ===
                                                       FORM_TYPE_EDIT
                                                            ? tableValueDetails.value
                                                            : null
                                                  }
                                             />
                                        ) : (
                                             <UiInput
                                                  type={
                                                       props.tableType ==
                                                       "Number"
                                                            ? "number"
                                                            : "text"
                                                  }
                                                  label="Value"
                                                  name="name"
                                                  maxLength={50}
                                                  allowedCharacters={/^[a-zA-Z0-9_ ]+$/}
                                             />
                                        )}
                                   </Grid>

                                   <Stack
                                        spacing={2}
                                        direction="row"
                                        justifyContent="end"
                                        sx={{
                                             width: "100%",
                                             mt: 3,
                                        }}
                                   >
                                        {props.type == FORM_TYPE_ADD && (
                                             <UiButton
                                                  onClick={closeFormModal}
                                                  name="Cancel"
                                                  variant="outlined"
                                                  size="small"
                                             />
                                        )}
                                        <UiButton
                                             name="Add"
                                             variant="contained"
                                             size="small"
                                             onClick={handleSubmit}
                                        />
                                   </Stack>
                              </Grid>
                         </>
                    </form>
               )}
          />
     );
}
